import React from 'react';
import Head from 'next/head';

export interface ScriptProps<T> {
  // JSON-serializable context object passed as parameter to wrapper function
  ctx: T;
  children: (ctx: T) => void;
}

/**
 * Pre connect a url
 */
export function preConnect(url: string, needConnect: string | boolean = true): JSX.Element | undefined {
  if (!needConnect) return;
  return (
    <React.Fragment>
      <link rel="preconnect" href={url} />
      <link rel="dns-prefetch" href={url} />
    </React.Fragment>
  );
}

/**
 * Make a script tag
 */
export function makeScript<T>(script: (ctx: T) => void, ctx: T): JSX.Element {
  return <script dangerouslySetInnerHTML={{ __html: `(${script.toString()})(${JSON.stringify(ctx || {})});` }} />;
}

/**
 * Load a script
 */
export function loadScript(url: string, id?: string) {
  const script = document.createElement('script');

  script.src = url;
  script.defer = true;
  // should not be set if you could control the response header
  // discussion: https://stackoverflow.com/questions/41069330/with-script-crossorigin-anonymous-why-is-a-script-blocked-by-cors-policy
  // script.crossOrigin = 'anonymous';

  if (id) {
    script.id = id;
  }

  document.body.appendChild(script);
}

/**
 * Check if a script is already loaded
 */
export function scriptAlreadyLoaded(id: string) {
  return !!document.getElementById(id);
}
